import React from 'react';

export type ClickOutsideTuple<T extends HTMLElement> = [React.RefObject<T>, boolean];

export const useClickOutside = <T extends HTMLElement>(): ClickOutsideTuple<T> => {
  const ref = React.useRef<T>(null);
  const [hasClickedOutside, setHasClickedOutside] = React.useState<boolean>(false);

  function handleEvent(e: Event) {
    if (ref && ref.current) {
      if (ref.current.contains(e.target as Node)) {
        setHasClickedOutside(false);
      } else {
        setHasClickedOutside(true);
      }
    }
  }

  React.useEffect(() => {
    if (window.PointerEvent) {
      document.addEventListener('pointerdown', handleEvent);
    } else {
      document.addEventListener('mousedown', handleEvent);
      document.addEventListener('touchstart', handleEvent);
    }

    return () => {
      if (window.PointerEvent) {
        document.removeEventListener('pointerdown', handleEvent);
      } else {
        document.removeEventListener('mousedown', handleEvent);
        document.removeEventListener('touchstart', handleEvent);
      }
    };
  }, []);

  return [ref, hasClickedOutside];
};
